import {isPlatformBrowser} from "@angular/common";
import {Config} from "../common/config";

export class WindowUtil {
  public static getLinkAddress(): string {
    if (isPlatformBrowser(Config.platformId)) {
      return window.location.href;
    }
    return Config.domain.DomainName;
  }
}
